/* eslint-disable */
import React, { useState, lazy, Suspense } from 'react';
import {
  LayoutDashboard, LifeBuoy, Monitor, Terminal, FileText
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Page from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
const DashboardView = lazy(() => import('./DashboardView'));
const SupportView = lazy(() => import('./SupportView'));
const SessionReplayView = lazy(() => import('./SessionReplayView'));
const AllSessionsView = lazy(() => import('./AllSessionsView'));
const ErrorLogsView = lazy(() => import('./ErrorLogsView'));
const AssessmentsView = lazy(() => import('./AssessmentsView'));
// 'replay' is intentionally not in this list — it's only reached by picking
// a ticket's "View Session Replay" button in the Support tab, not as its own tab.
const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'support', label: 'Support & CCI', icon: LifeBuoy },
  { id: 'sessions', label: 'All Sessions', icon: Monitor },
  { id: 'errors', label: 'Error Logs', icon: Terminal },
  { id: 'assessments', label: 'Assessments', icon: FileText },
];
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
  </div>
);
const AnalyticsDashboard = () => {
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('dashboard');
  const [selectedTicket, setSelectedTicket] = useState(null);
  const handleViewReplay = (ticket) => {
    setSelectedTicket(ticket);
    setActiveView('replay');
  };
  const renderContent = () => {
    switch (activeView) {
      case 'dashboard':
        return <DashboardView />;
      case 'support':
        return <SupportView onViewReplay={handleViewReplay} />;
      case 'sessions':
        return <AllSessionsView />;
      case 'errors':
        return <ErrorLogsView />;
      case 'assessments':
        return <AssessmentsView />;
      case 'replay':
        return <SessionReplayView ticket={selectedTicket} />;
      default:
        return <DashboardView />;
    }
  };
  return (
    <Page title="Analytics">
      <PageHeader
        pageTitle="Analytics"
        subTitle="Product usage, support tickets, and session replay."
        onBack={() => navigate('/app/dashboard')}
      />
      {/* Top Tabs */}
      <div className="flex items-center gap-1 bg-white p-1 rounded-xl border border-gray-200 mb-4 overflow-x-auto">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.id || (item.id === 'support' && activeView === 'replay');
          return (
            <button
              key={item.id}
              onClick={() => setActiveView(item.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-all ${
                isActive
                  ? 'bg-blue-50 text-blue-600 border border-blue-200'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100 border border-transparent'
              }`}
            >
              <Icon className="w-4 h-4" />
              {item.label}
            </button>
          );
        })}
      </div>
      {/* Main Content */}
      <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 min-h-[500px]">
        <Suspense fallback={<LoadingFallback />}>
          {renderContent()}
        </Suspense>
      </div>
    </Page>
  );
};

export default AnalyticsDashboard;
